<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}">
    <div class="position: relative;">
      <!-- .custom-company-cooperation === ccc -->
      <!-- 设置内容 -->
      <div class="ccc">
        <div class="cccp-content">
          <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{Modal}}</div> -->
          <iSwitch size="large" v-model="Modal.isOpen">
            <span slot="open">开启</span>
            <span slot="close">关闭</span>
          </iSwitch>
          <span class="ccc-info">banner设置</span>
          <div style="padding-top: 30px;" v-if="Modal.isOpen">
            <Form ref="form" :rules="ruleValidate">
              <FormItem prop="proImg">
                <div>
                  <upload
                    ref="upload1"
                    :fileList="uploadBanner"
                    :config="uploadBannerConfig"
                    @upload-ok="bannerOK"
                  />
                </div>
              </FormItem>
              <FormItem prop="proVideo">
                <div>
                  <upload
                    :config="uploadVideoConfig"
                    @upload-ok="videoOK"
                    :fileList="uploadVideo"
                    class="upload-1"
                    ref="upload2"
                  />
                </div>
              </FormItem>
            </Form>
          </div>
          <div class="f-tar">
            <Button 
              type="primary"
              @click="saveCustom()"
              :loading="loading"
            >保存</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import upload from "@components/upLoad/upLoad";

export default {
  // 顶部banner
  name: "custom-company-banner",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return {
          type: 1, //类型Id
          isOpen: false, //是否开启
          coverType: "0", // 视频封面类型 0 截取 1 自定义
          cover: "", // 封面
          time: 2000, // 视频封面截取帧
          path: "", // 视频地址
          list: []
        };
      }
    }
  }, 
  data() {
    const validateProImg = (rule, value, callback) => {
      if (this.uploadBanner && this.uploadBanner.length) {
        callback();
      } else {
        callback(new Error("请上传产品图片"));
      }
    };
    const validateProVideo = (rule, value, callback) => {
      if (this.uploadVideo && this.uploadVideo.length) {
        callback();
      } else {
        callback(new Error("请上传产品视频"));
      }
    };
    return {
      loading: false,
      visible: false,

      editData: "",

      uploadBanner: [], // 产品图
      uploadVideo: [], // 主图视频
      applyDate: [], // 体验报名时间
      config: {
        fileType: "img",
        headers: {},
        action: "",
        format: ["jpg", "jpeg", "png"],
        "max-size": 2048,
        remind:
          "(图片要求：2M以下的jpg或png，建议尺寸为750*420px，最多上传4张)",
        limitNum: 4
      },
      ruleValidate: {
        proImg: [
          { required: true, validator: validateProImg, trigger: "change" }
        ],
        proVideo: [
          { required: true, validator: validateProVideo, trigger: "change" }
        ]
      },
      videoList: [] // 视频详情
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      if (val !== this.index) this.visible = false;
    },
    Modal() {
      this.init();
    },
    currentSave(val, oldVal) {
      this.loading = val;
    }
  },
  computed: {
    ...mapGetters({
      currentSave: "customCompanyModule/getCurrent",
      activeIndex: "customCompanyModule/getActiveIndex",
      uploadUrl: "getUploadUrl",
      uploadVideoUrl: "getUploadVideoUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany"
    }),
    uploadBannerConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_1";
      config.headers = this.formHeaders;
      config.action = this.uploadUrl;
      return config;
    },
    uploadVideoConfig() {
      let config = JSON.parse(JSON.stringify(this.config));
      config.id = "upload_2";
      config.fileType = "video";
      config.headers = this.formHeaders;
      config.action = this.uploadVideoUrl;
      config.format = ["mp4"];
      config["max-size"] = 51200; // 50M
      config.limitNum = 1;
      config.remind =
        "(视频要求：视频大小不超过50M，建议视频时长9-30秒，视频宽高比16:9)";
      return config;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customCompanyModule/setActiveIndex",
      setCurrent: "customCompanyModule/setCurrent",
    }),
    ...mapActions({
      getProductById: "productModule/getProductById",
      editProduct: "productModule/editProduct"
    }),
    setVisible() {
      this.setActiveIndex(this.index);
      this.visible = !this.visible;
    },
    async init() {
      let arr = [];
      this.Modal.list.forEach(c => {
        arr.push(c.path);
      });
      this.uploadBanner = arr;
      if (this.Modal.path) {
        this.uploadVideo = [
          {
            url: this.Modal.path,
            src: this.Modal.cover
          }
        ];
      }
    },
    bannerOK(list) {
      this.uploadBanner = list;
      if (list) {
        const arr = [];
        list.forEach(c => {
          arr.push({
            path: c, //图片路径
            link: "" //链接地址
          });
        });
        this.Modal.list = arr;
      }
    },
    videoOK(list) {
      this.uploadVideo = list;
      if (list && list[0]) {
        this.Modal.coverType = "0";
        this.Modal.cover = list[0].src;
        this.Modal.path = list[0].url;
        let str = this.getIntArr(list[0].src);
        if (str && str.length) {
          this.Modal.time = str.reverse()[2];
        }
      } else {
        const copyData = JSON.parse(JSON.stringify(this.Modal));
        copyData.cover = "";
        copyData.time = 2000;
        copyData.path = "";
        copyData.coverType = "0";
        this.$emit("sendModal", copyData);
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    getIntArr(str) {
      return str
        .replace(/[^0-9]/gi, " ")
        .trim()
        .split(/\s+/);
    },
    saveCustom() {
      this.setCurrent(true);
    }
  },
  components: {
    upload
  }
};
</script> 
<style scoped lang="scss">
.ccc {
  width: 100%;
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  .cccp {
    &-title {
      padding: 20px 30px;
      font-size: 14px;
      color: #333;
      border-bottom: solid 1px #ddd;
    }
    &-content {
      padding: 40px 50px;
      .addlink {
        border: dashed 1px #bfbfbf;
        text-align: center;
        color: #1890ff;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
</style>
